import "./styles.scss";

const ImageNonResponsive = ({
  alt = "",
  filename,
  onClick = () => {},
  title = "",
  className = "",
  imageClassName = "",
}) => {
  const fullFilePath = "https://yurqua.github.io/rbs/docs/assets/" + filename;
  return (
    <div className={["image-block", className].join(" ").trim()}>
      <picture>
        <source
          srcSet={`${fullFilePath}.webp`}
          type="image/webp"
        />
        <source
          srcSet={`${fullFilePath}.jpg`}
          type="image/jpeg"
        />
        <img
          src={`${fullFilePath}.jpg`}
          className={["img", imageClassName].join(" ").trim()}
          alt={alt}
          title={title}
          onClick={onClick}
        />
      </picture>
    </div>
  );
};
export default ImageNonResponsive;
